$(document).ready(function(){
    console.log("custom swatch init");
    $(document).on("change",".customer-color-values input",function(){
        var url = $(this).attr("data-variant-url");
        if(url != '')
        {
            $(this).parents(".product-card-wrapper").find("a").attr("href",url);
            let img = $(this).next("label").attr("data-img-url");
            let vid = $(this).next("label").attr("data-tier-variant-id");
            $(this).parents(".product-card-wrapper").find(".card__media img").attr("src",img);
            $(this).parents(".product-card-wrapper").find(".card__media img").attr("srcset",img);
            $(this).parents(".product-card-wrapper").next("product-form").find("[name=id]").val(vid);
        }
    });

    $(document).on({
        mouseenter: function () {
            //stuff to do on mouse enter
            let img = $(this).attr("data-img-url");
            $(this).parents(".product-card-wrapper").find(".card__media img").attr("src",img);
            $(this).parents(".product-card-wrapper").find(".card__media img").attr("srcset",img);
        },
        mouseleave: function () {
            //stuff to do on mouse leave
            let img = $(this).parents(".product-card-wrapper").find(".customer-color-values label.selected").attr("data-img-url");
            $(this).parents(".product-card-wrapper").find(".card__media img").attr("src",img);
            $(this).parents(".product-card-wrapper").find(".card__media img").attr("srcset",img);
        }
    }, ".customer-color-values label");

    // $(".customer-color-values label").hover(function(){
    //     let img = $(this).attr("data-img-url");
    //     $(this).parents(".product-card-wrapper").find(".card__media img").attr("src",img);
    //     $(this).parents(".product-card-wrapper").find(".card__media img").attr("srcset",img);
    // }, function(){
    //     let img = $(this).parents(".product-card-wrapper").find(".customer-color-values label.selected").attr("data-img-url");
    //     $(this).parents(".product-card-wrapper").find(".card__media img").attr("src",img);
    //     $(this).parents(".product-card-wrapper").find(".card__media img").attr("srcset",img);
    // });
});